import {
  GALLERY_ADD_FAIL,
  GALLERY_ADD_REQUEST,
  GALLERY_ADD_RESET,
  GALLERY_ADD_SUCCESS,
  GALLERY_DELETE_FAIL,
  GALLERY_DELETE_REQUEST,
  GALLERY_DELETE_SUCCESS,
  GALLERY_DETAIL_FAIL,
  GALLERY_DETAIL_REQUEST,
  GALLERY_DETAIL_SUCCESS,
  GALLERY_LIST_FAIL,
  GALLERY_LIST_REQUEST,
  GALLERY_LIST_SUCCESS,
  GALLERY_UPDATE_FAIL,
  GALLERY_UPDATE_REQUEST,
  GALLERY_UPDATE_RESET,
  GALLERY_UPDATE_SUCCESS,
} from "../constants/galleryConstant";

export const listGalleryReducer = (state = {}, action) => {
  switch (action.type) {
    case GALLERY_LIST_REQUEST:
      return {
        loading: true,
      };
    case GALLERY_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        gallerys: action.payload,
      };

    case GALLERY_LIST_FAIL:
      return {
        loading: true,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const galleryDetailReducer = (state = {}, action) => {
  switch (action.type) {
    case GALLERY_DETAIL_REQUEST:
      return {
        loading: true,
      };
    case GALLERY_DETAIL_SUCCESS:
      return {
        loading: false,
        success: true,
        gallery: action.payload,
      };

    case GALLERY_DETAIL_FAIL:
      return {
        loading: true,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const galleryAddReducer = (state = {}, action) => {
  switch (action.type) {
    case GALLERY_ADD_REQUEST:
      return {
        loading: true,
      };
    case GALLERY_ADD_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case GALLERY_ADD_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case GALLERY_ADD_RESET:
      return {
        loading: true,
        success: false,
      };
    default:
      return state;
  }
};
export const galleryEditReducer = (state = {}, action) => {
  switch (action.type) {
    case GALLERY_UPDATE_REQUEST:
      return {
        loading: true,
      };
    case GALLERY_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case GALLERY_UPDATE_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case GALLERY_UPDATE_RESET:
      return {
        loading: true,
        success: false,
      };
    default:
      return state;
  }
};
export const galleryDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case GALLERY_DELETE_REQUEST:
      return {
        loading: true,
      };
    case GALLERY_DELETE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case GALLERY_DELETE_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
